/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Win_Back_Paywall_Subscribed_Success_TitleInputs */

const en_win_back_paywall_subscribed_success_title = /** @type {(inputs: Win_Back_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Plus subscription is confirmed`)
};

const ar_win_back_paywall_subscribed_success_title = /** @type {(inputs: Win_Back_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تأكيد اشتراكك في Plus`)
};

const de_win_back_paywall_subscribed_success_title = /** @type {(inputs: Win_Back_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Plus-Abo ist bestätigt`)
};

const es_win_back_paywall_subscribed_success_title = /** @type {(inputs: Win_Back_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu suscripción a Plus está confirmada`)
};

const fr_win_back_paywall_subscribed_success_title = /** @type {(inputs: Win_Back_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton abonnement Plus est confirmé`)
};

const it_win_back_paywall_subscribed_success_title = /** @type {(inputs: Win_Back_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo abbonamento Plus è confermato`)
};

const ja_win_back_paywall_subscribed_success_title = /** @type {(inputs: Win_Back_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusの登録が完了しました`)
};

const ko_win_back_paywall_subscribed_success_title = /** @type {(inputs: Win_Back_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 구독이 확인되었어요`)
};

const pt_br_win_back_paywall_subscribed_success_title = /** @type {(inputs: Win_Back_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua assinatura Plus está confirmada`)
};

const ru_win_back_paywall_subscribed_success_title = /** @type {(inputs: Win_Back_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша подписка Plus подтверждена`)
};

const th_win_back_paywall_subscribed_success_title = /** @type {(inputs: Win_Back_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยืนยันการสมัครสมาชิก Plus แล้ว`)
};

const tr_win_back_paywall_subscribed_success_title = /** @type {(inputs: Win_Back_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus aboneliğin onaylandı`)
};

const zh_cn_win_back_paywall_subscribed_success_title = /** @type {(inputs: Win_Back_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 订阅已确认`)
};

const zh_tw_win_back_paywall_subscribed_success_title = /** @type {(inputs: Win_Back_Paywall_Subscribed_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 訂閱已確認`)
};

/**
* | output |
* | --- |
* | "Your Plus subscription is confirmed" |
*
* @param {Win_Back_Paywall_Subscribed_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const win_back_paywall_subscribed_success_title = /** @type {((inputs?: Win_Back_Paywall_Subscribed_Success_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Win_Back_Paywall_Subscribed_Success_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_win_back_paywall_subscribed_success_title(inputs)
	if (locale === "ar") return ar_win_back_paywall_subscribed_success_title(inputs)
	if (locale === "de") return de_win_back_paywall_subscribed_success_title(inputs)
	if (locale === "es") return es_win_back_paywall_subscribed_success_title(inputs)
	if (locale === "fr") return fr_win_back_paywall_subscribed_success_title(inputs)
	if (locale === "it") return it_win_back_paywall_subscribed_success_title(inputs)
	if (locale === "ja") return ja_win_back_paywall_subscribed_success_title(inputs)
	if (locale === "ko") return ko_win_back_paywall_subscribed_success_title(inputs)
	if (locale === "pt_br") return pt_br_win_back_paywall_subscribed_success_title(inputs)
	if (locale === "ru") return ru_win_back_paywall_subscribed_success_title(inputs)
	if (locale === "th") return th_win_back_paywall_subscribed_success_title(inputs)
	if (locale === "tr") return tr_win_back_paywall_subscribed_success_title(inputs)
	if (locale === "zh_cn") return zh_cn_win_back_paywall_subscribed_success_title(inputs)
	return zh_tw_win_back_paywall_subscribed_success_title(inputs)
});